import { object, string, create, optional, nullable } from 'superstruct'

export const CreateParams = object({
  currency: string(),
  priceBase: string(),
  priceDiscount: optional(string()),
  priceFinal: string(),
  discountType: optional(nullable(string())),
  discountReason: optional(nullable(string())),
  exemptionType: optional(nullable(string())),
  exemptionReason: optional(nullable(string())),
  // The core API serializes discount/exemption as nested objects ({ type, reason, author }).
  // Keep them on the model so the athlete-facing views can read `pricing.exemption?.type`
  // (e.g. the world-champion exemption), mirroring the staff payment views.
  discount: optional(nullable(object())),
  exemption: optional(nullable(object()))
})

export class Pricing {
  static create(params) {
    return new Pricing(create(params, CreateParams))
  }

  constructor(params) {
    Object.assign(this, params)
  }
}
